// custom-cart.js

// Function to refresh cart drawer
async function refreshCartDrawer() {

    console.log("===>>> refresh cart drawer run")
    try {
        const response = await fetch('/?sections=cart-drawer');
        const data = await response.json();
        
        const cartDrawerHTML = data['cart-drawer'];

        const parser = new DOMParser();
        const newDocument = parser.parseFromString(cartDrawerHTML, 'text/html');
        console.log("===>> new document is: ", newDocument.querySelector('cart-drawer'))
        document.querySelector("cart-drawer").replaceWith(newDocument.querySelector("cart-drawer"));
        
        // cartDrawer.open();  // Reopen cart drawer if it was open

        console.log("Cart drawer updated successfully.");
        return true;
    } catch (error) {
        console.error('Error refreshing cart drawer:', error);
        return false;
    }
}

// Function to add items to cart
async function addToCart(variantId, quantity = 1) {
    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: variantId,
                quantity: quantity
            })
        });

        await response.json();
        document.querySelector("cart-drawer").classList.remove("is-empty");
        await refreshCartDrawer();  // Refresh cart drawer after adding
        const cartDrawer = document.querySelector('cart-drawer');
        cartDrawer.open();  // Reopen cart drawer if it was open
    } catch (error) {
        console.error('Error adding to cart:', error);
    }
}

// Function to update item quantity in cart
async function updateCartItem(variantId, quantity) {
    try {
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: variantId,
                quantity: quantity
            })
        });

        await response.json();
        await refreshCartDrawer();  // Refresh cart drawer after updating
    } catch (error) {
        console.error('Error updating cart:', error);
    }
}
